
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Navigation } from "@/components/Navigation";
import { useNavigate } from "react-router-dom";
import { ImageIcon, BookOpenIcon, FileText } from "lucide-react";

export default function Create() {
  const navigate = useNavigate();

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.3
      } 
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <div className="min-h-screen">
      <Navigation />
      <motion.main 
        className="container mx-auto px-4 pt-24 pb-16"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 
          className="text-2xl font-bold mb-8"
          variants={itemVariants}
        >
          O que você quer criar hoje?
        </motion.h1>
        
        <div className="grid md:grid-cols-3 gap-6">
          <motion.div
            variants={itemVariants}
            whileHover={{ 
              scale: 1.03, 
              boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.1)",
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.98 }}
          >
            <Card 
              className="p-6 cursor-pointer hover:shadow-lg transition-shadow group"
              onClick={() => navigate("/create/pin")}
            >
              <div className="flex items-center gap-4 mb-4">
                <motion.div 
                  className="p-3 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <ImageIcon className="h-6 w-6" />
                </motion.div>
                <h2 className="text-xl font-semibold">Ink Pin</h2>
              </div>
              <p className="text-muted-foreground">
                Compartilhe suas ilustrações, designs, mangás e arte digital com a comunidade.
              </p>
            </Card>
          </motion.div>

          <motion.div
            variants={itemVariants}
            whileHover={{ 
              scale: 1.03, 
              boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.1)",
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.98 }}
          >
            <Card 
              className="p-6 cursor-pointer hover:shadow-lg transition-shadow group"
              onClick={() => navigate("/create/webtoon")}
            >
              <div className="flex items-center gap-4 mb-4">
                <motion.div 
                  className="p-3 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
                  whileHover={{ scale: 1.1, rotate: -5 }}
                  transition={{ duration: 0.2 }}
                >
                  <BookOpenIcon className="h-6 w-6" />
                </motion.div>
                <h2 className="text-xl font-semibold">Webtoon</h2>
              </div>
              <p className="text-muted-foreground">
                Publique sua história em quadrinhos no formato webtoon com episódios.
              </p>
            </Card>
          </motion.div>

          <motion.div
            variants={itemVariants}
            whileHover={{ 
              scale: 1.03, 
              boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.1)",
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.98 }}
          >
            <Card 
              className="p-6 cursor-pointer hover:shadow-lg transition-shadow group"
              onClick={() => navigate("/create/webnovel")}
            >
              <div className="flex items-center gap-4 mb-4">
                <motion.div 
                  className="p-3 rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <FileText className="h-6 w-6" />
                </motion.div>
                <h2 className="text-xl font-semibold">Webnovel</h2>
              </div>
              <p className="text-muted-foreground">
                Escreva e publique sua própria webnovel com capítulos e uma história envolvente.
              </p>
            </Card>
          </motion.div>
        </div>
      </motion.main>
    </div>
  );
}
